import { render, staticRenderFns } from "./InspectionItemManage.vue?vue&type=template&id=6b0d5ffb&scoped=true"
import script from "./InspectionItemManage.vue?vue&type=script&lang=js"
export * from "./InspectionItemManage.vue?vue&type=script&lang=js"
import style0 from "./InspectionItemManage.vue?vue&type=style&index=0&id=6b0d5ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d5ffb",
  null
  
)

export default component.exports